import { useSelector } from 'react-redux'
import { isEqual } from 'lodash'
import { OnboardingLoader } from './OnboardingLoader'
import { RootState } from 'types'
import { useEffect, useState } from 'react'
import { useInvitedWorkspace } from 'hooks/useInvitedWorkspace'
import { useWorkspaceInviteToken } from 'utils/workspaceUtils'

export const OnboardingLoaderContainer = () => {
  const [shown, setShown] = useState(false)
  const show = useSelector(({ onboardingLoaderVisible }: RootState) => onboardingLoaderVisible, isEqual)
  const workspaceInviteToken = useWorkspaceInviteToken()
  const { workspace: invitedWorkspace } = useInvitedWorkspace(workspaceInviteToken)

  useEffect(() => {
    if (show) {
      setShown(show)
    } else {
      // Hide case, wait for the fade out animation to finish
      setTimeout(() => {
        setShown(false)
      }, 1000)
    }
  }, [show])

  if (!shown) return null

  return <OnboardingLoader fadeIn={shown} fadeOut={shown && !show} workspace={invitedWorkspace} />
}
